export default {
  ADD: "green",
  DELETE: "red",
  MASS_DELETE: "red",
  UPDATE: "blue",
};
